'use strict'

export class UserService {
  constructor($http, $mdToast, $timeout, UserFactory) {
    'ngInject'
    Object.assign(this, { $http, $mdToast, $timeout, UserFactory })
  }

  get(id) {
    return this.$http({
      method: 'GET',
      url: '/api/users/' + id,
      cache: true,
    }).then((res) => {
      const user = res.data.user
      const customers = res.data.customers.filter((customer) => !!customer.customer)
      return new this.UserFactory({
        user,
        customers,
      })
    })
  }

  patchMe(newUserData) {
    return this.$http({
      method: 'PATCH',
      url: '/api/users/me',
      data: newUserData,
    }).then((result) => result.data)
  }

  me() {
    return this.get('me')
  }

  getInvitation(token) {
    return this.$http({
      method: 'GET',
      url: '/api/invitations/' + token,
    }).then((result) => result.data)
  }

  acceptInvitation(token) {
    const patchData = { status: 'active' }

    return this.$http({
      method: 'PATCH',
      url: '/api/invitations/' + token,
      data: patchData,
    })
  }

  // TODO customer name besser auslesen
  acceptMyPermissions(permissions) {
    const patchData = []
    permissions.forEach((permission) => {
      patchData.push({
        id: permission._id,
        status: 'ACTIVE',
      })
    })

    return this.$http({
      method: 'PATCH',
      url: '/api/users/me/permissions',
      data: patchData,
    })
  }
}



// WEBPACK FOOTER //
// ./app/shared/services/user.service.js